export function useOnClick(props) {
  return function onClick() {
    try {
      window.close()
    } catch (_) {}
  }
}
